import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ThemeCard from "./ThemeCard";
import Lottie from "lottie-react";

function ThemesSection() {
    const { t } = useTranslation("global");
    const [animationData, setAnimationData] = useState(null);
    const [activeTab, setActiveTab] = useState(1); // Default to Level 1
    
    // Level 1 themes - using translations for title, description, and icon
    const level1Themes = [
      {
        title: t("themes.level1-theme1-title", "Sécurité de l'information (SSI)"),
        description: t("home.second-feature-1"),
        icon: t("themes.icon-ssi", "SSI"),
      },
      {
        title: t("themes.level1-theme2-title", "Qualité, Sécurité & santé au travail, Environnement (QSE)"),
        description: t("home.second-feature-2"),
        icon: t("themes.icon-qse", "QSE"),
      },
      {
        title: t("themes.level1-theme3-title", "Responsabilité Sociétale des Entreprises (RSE)"),
        description: t("home.second-feature-3"),
        icon: t("themes.icon-rse", "RSE"),
      },
    ];
    
    // Level 2 themes - 4 main themes with ISO standards
    const level2Themes = [
      {
        title: t("themes.level2-theme1-title", "Sécurité de l'information (SSI/ISO 27001)"),
        description: t("themes.level2-theme1-description", "Évaluation complète de la sécurité de l'information selon la norme ISO 27001"),
        icon: t("themes.icon-ssi", "SSI"),
      },
      {
        title: t("themes.level2-theme2-title", "Qualité, Sécurité & santé au travail, Environnement (QSE/ISO 9001, 45001, 14001)"),
        description: t("themes.level2-theme2-description", "Évaluation QSE basée sur les normes ISO 9001, 45001 et 14001"),
        icon: t("themes.icon-qse", "QSE"),
      },
      {
        title: t("themes.level2-theme3-title", "Responsabilité Sociétale des Entreprises (RSE)"),
        description: t("themes.level2-theme3-description", "Évaluation RSE adaptée à la taille de votre entreprise"),
        icon: t("themes.icon-rse", "RSE"),
      },
      {
        title: t("themes.level2-theme4-title", "Protection des Données (RGPD)"),
        description: t("themes.level2-theme4-description", "Évaluation de la conformité au Règlement Général sur la Protection des Données"),
        icon: t("themes.icon-rgpd", "RGPD"),
      },
    ];
    
    return (
      <section id="themes" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-black">
              {t("home.second-section-title")}
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto mt-4">
              {t("themes.section-subtitle", "Découvrez nos thématiques d'évaluation, adaptées aux besoins de votre entreprise")}
            </p>
            <div className="w-20 h-1 bg-blue-600 mx-auto mt-4"></div>
          </div>
          
          {/* Tabs for level selection */}
          <div className="flex justify-center mb-10">
            <div className="inline-flex rounded-md shadow-sm">
              <button
                onClick={() => setActiveTab(1)}
                className={`px-6 py-3 text-sm font-medium rounded-l-lg ${
                  activeTab === 1
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
                aria-pressed={activeTab === 1}
              >
                {t("themes.level1-tab", "Niveau 1")}
              </button>
              <button
                onClick={() => setActiveTab(2)}
                className={`px-6 py-3 text-sm font-medium rounded-r-lg ${
                  activeTab === 2
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
                aria-pressed={activeTab === 2}
              >
                {t("themes.level2-tab", "Niveau 2")}
              </button>
            </div>
          </div>
          
          {/* Theme cards grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
            {activeTab === 1 ? (
              // Display Level 1 themes
              level1Themes.map((theme, index) => (
                <ThemeCard
                  key={`level1-${index}`}
                  title={theme.title}
                  description={theme.description}
                  icon={theme.icon}
                  level="1"
                  isExpandable={true}
                />
              ))
            ) : (
              // Display Level 2 themes
              level2Themes.map((theme, index) => (
                <ThemeCard
                  key={`level2-${index}`}
                  title={theme.title}
                  description={theme.description}
                  icon={theme.icon}
                  level="2"
                  isExpandable={true}
                />
              ))
            )}
          </div>
        </div>
      </section>
    );
  }
  
  export default ThemesSection;